import { useState } from "react";
import "./WeldingCalculator.css";
import { Link } from 'react-router-dom';
import { FaFacebook } from "react-icons/fa";

const WeldingCalculator = () => {
  const [method, setMethod] = useState("MIG");
  const [material, setMaterial] = useState("stal_niskoweglowa");
  const [jointType, setJointType] = useState("czolowe");
  const [thickness, setThickness] = useState("3"); // trzymamy jako string
  const [electrode, setElectrode] = useState(0.8);

  const materialFactor = {
    stal_niskoweglowa: 1.0,
    stal_stopowa: 1.1,
    nierdzewna: 1.05,
    aluminium: 1.2,
    stopy_aluminium: 1.25,
    miedz: 1.4,
  };

  const jointFactor = {
    czolowe: 1.0,
    pachwinowe: 1.15,
    zakladkowe: 1.1,
    narozne: 1.1,
  };

  const calculate = () => {
    const thicknessValue = parseFloat(thickness) || 0;
    if (thicknessValue <= 0) {
      return { current: "-", wireSpeed: "-", speed: "-" };
    }

    let result = {};
    const matFactor = materialFactor[material];
    const jFactor = jointFactor[jointType];

    /* ================= MIG / MAG ================= */
    if (method === "MIG") {
      let baseMin = thicknessValue * 30;
      let baseMax = thicknessValue * 40;

      let wireSpeed = "";
      let diameterFactor = 1;
      let warning = "";

      switch (electrode) {
        case 0.8:
          wireSpeed = "2.5 – 4.5 m/min";
          diameterFactor = 0.9;
          break;
        case 1.0:
          wireSpeed = "3.5 – 6.5 m/min";
          diameterFactor = 1.0;
          break;
        case 1.2:
          wireSpeed = "4.5 – 8.0 m/min";
          diameterFactor = 1.1;
          break;
        case 1.6:
          wireSpeed = "5.0 – 9.0 m/min";
          diameterFactor = 1.25;
          if (thicknessValue < 5)
            warning = "⚠ Drut 1.6 mm zalecany powyżej ~5 mm grubości.";
          break;
        case 2.0:
          wireSpeed = "6.0 – 10.0 m/min";
          diameterFactor = 1.4;
          if (thicknessValue < 8)
            warning = "⚠ Drut 2.0 mm zalecany powyżej ~8 mm grubości.";
          break;
        case 2.4:
          wireSpeed = "7.0 – 12.0 m/min";
          diameterFactor = 1.55;
          if (thicknessValue < 12)
            warning = "⚠ Drut 2.4 mm zalecany powyżej ~12 mm grubości.";
          break;
        default:
          break;
      }

      const minCurrent = Math.round(
        baseMin * matFactor * jFactor * diameterFactor * 0.85
      );
      const maxCurrent = Math.round(
        baseMax * matFactor * jFactor * diameterFactor * 0.85
      );

      result = {
        current: `${minCurrent} – ${maxCurrent} A`,
        wireSpeed,
        warning,
      };
    }

    /* ================= TIG ================= */
    if (method === "TIG") {
      let baseMin = thicknessValue * 35;
      let baseMax = thicknessValue * 50;

      const minCurrent = Math.round(baseMin * matFactor * jFactor * 0.85);
      const maxCurrent = Math.round(baseMax * matFactor * jFactor * 0.85);

      result = {
        current: `${minCurrent} – ${maxCurrent} A`,
        speed: "8 – 20 cm/min",
      };
    }

    /* ================= MMA ================= */
    if (method === "MMA") {
      let current = "";

      if (electrode === 2.0) current = "40 – 70 A";
      if (electrode === 2.5) current = "70 – 100 A";
      if (electrode === 3.2) current = "100 – 140 A";
      if (electrode === 4.0) current = "140 – 190 A";

      result = {
        current,
        speed: "10 – 25 cm/min",
      };
    }

    return result;
  };

  const result = calculate();

  return (
    <div className="welding-container">
      <h2>Kalkulator parametrów spawania</h2>

      <div className="info-box">
        <p>
          ⚠ Wartości mają charakter orientacyjny i stanowią punkt startowy do
          ustawień spawarki. Rzeczywiste parametry należy dostosować do
          konkretnej maszyny, rodzaju gazu osłonowego oraz techniki spawania.
        </p>
        <p className="info-source">
          Źródło: ogólne tabele producentów urządzeń spawalniczych (np. ESAB,
          Lincoln Electric, Kemppi) oraz materiały branżowe dotyczące MIG/MAG,
          TIG i MMA.
        </p>
      </div>

      <div className="form-group">
        <label>Metoda spawania</label>
        <select value={method} onChange={(e) => setMethod(e.target.value)}>
          <option value="MIG">MIG / MAG</option>
          <option value="TIG">TIG</option>
          <option value="MMA">MMA</option>
        </select>
      </div>

      <div className="form-group">
        <label>Rodzaj materiału</label>
        <select value={material} onChange={(e) => setMaterial(e.target.value)}>
          <option value="stal_niskoweglowa">Stal niskowęglowa</option>
          <option value="stal_stopowa">Stal stopowa</option>
          <option value="nierdzewna">Stal nierdzewna</option>
          <option value="aluminium">Aluminium</option>
          <option value="stopy_aluminium">Stopy aluminium</option>
          <option value="miedz">Miedź</option>
        </select>
      </div>

      <div className="form-group">
        <label>Typ złącza</label>
        <select value={jointType} onChange={(e) => setJointType(e.target.value)}>
          <option value="czolowe">Czołowe</option>
          <option value="pachwinowe">Pachwinowe</option>
          <option value="zakladkowe">Zakładkowe</option>
          <option value="narozne">Narożne</option>
        </select>
      </div>

      <div className="form-group">
        <label>Grubość materiału (mm)</label>
        <input
          type="number"
          min="0"
          step="0.1"
          value={thickness}
          onChange={(e) => setThickness(e.target.value)}
        />
      </div>

      <div className="form-group">
        <label>
          {method === "MMA"
            ? "Średnica elektrody (mm)"
            : "Średnica drutu (mm)"}
        </label>

        <select
          value={electrode}
          onChange={(e) => setElectrode(Number(e.target.value))}
        >
          {method === "MMA" ? (
            <>
              <option value={2.0}>2.0</option>
              <option value={2.5}>2.5</option>
              <option value={3.2}>3.2</option>
              <option value={4.0}>4.0</option>
            </>
          ) : (
            <>
              <option value={0.8}>0.8</option>
              <option value={1.0}>1.0</option>
              <option value={1.2}>1.2</option>
              <option value={1.6}>1.6</option>
              <option value={2.0}>2.0</option>
              <option value={2.4}>2.4</option>
            </>
          )}
        </select>
      </div>

      <div className="result-box">
        <h3>Rekomendowane ustawienia</h3>
        <p><strong>Prąd:</strong> {result.current}</p>

        {method === "MIG" && (
          <>
            <p><strong>Posuw drutu:</strong> {result.wireSpeed}</p>
            {result.warning && (
              <p style={{ color: "red", marginTop: "8px" }}>
                {result.warning}
              </p>
            )}
          </>
        )}

        {(method === "TIG" || method === "MMA") && (
          <p><strong>Prędkość spawania:</strong> {result.speed}</p>
        )}
      </div>

      <div className="CalculatorLogosMainDiv">
        <Link to='/' className='MainLogoText'>
           SteelJobs.pl
        </Link>
        <p>Oferty pracy z branży metalurgicznej</p>
        <a className='FooterLink' >steeljobs@steeljobs.pl</a>

        <a 
          href="https://www.facebook.com/profile.php?id=100083031086146" 
          target="_blank" 
          rel="noopener noreferrer"
        >
          <FaFacebook className='MainPageFBIcon'/>
        </a>
      </div>

    </div>
  );
};

export default WeldingCalculator;
